import { DateTime } from "luxon";

function getActiveMessage(lastTime) {
  function inLastNDays(n, timestamp) {
    let checkDate = new Date(timestamp);
    let today = new Date(),
      lasNday = new Date();
    lasNday.setDate(lasNday.getDate() - n);
    return checkDate < today && checkDate > lasNday;
  }

  if (inLastNDays(7, lastTime)) return "Active This Week";
  if (inLastNDays(30, lastTime)) return "Active this Month";
  if (inLastNDays(90, lastTime)) return "Active 3 months ago";
  return "Active 6 months ago";
}

export const getMappedPatientForSafe = (patient) => {
  var obj = {};
  obj.procedureDate = {
    label: patient.next_schedule
      ? DateTime.fromMillis(patient.next_schedule).toFormat("DD")
      : "-",
    tags: patient.tag,
  };

  obj.patient = {
    label: patient.aid,
    subLabel: patient.activity ? getActiveMessage(patient.activity) : "-",
    redirectPath: `/patient/${patient.id}`,
  };

  obj.nextEvent = {
    label: patient.next_schedule_event ? patient.next_schedule_event : "-",
    subLabel: patient.next_schedule
      ? DateTime.fromMillis(patient.next_schedule).toFormat("DD")
      : "-",
    redirectPath: `/patient/${patient.id}`,
  };
  let completed = 0
  if (patient.questionnaire) {
    completed = patient.questionnaire.reduce((acc, val) => {
      if (val.completed) return acc + 1;
      return acc;
    }, 0);
  }

  obj.qnairs = {
    label: (patient.questionnaire)
      ? `${completed} of ${patient.questionnaire.length}`
      : "-",
    redirectPath: `/patient/${patient.id}/response`,
    data: [],
  };

  obj.surveys = {
    label: patient.survey.length,
    redirectPath: `/patient/${patient.id}/record`,
    flag: patient.survey.reduce((acc, val) => {
      if (val.modified_by) {
        if (acc.open) {
          acc.open = acc.open + 1;
        } else acc.open = 1;
        return acc;
      }
      if (acc.closed) acc.closed = acc.closed + 1;
      else acc.closed = 1;
      return acc;
    }, {}),
  };
  obj.files = {
    label: patient.file.length,
    redirectPath: `/patient/${patient.id}/record`,
    data: patient.file.map((ele) => ({
      label: ele.name,
      id: ele.id,
    })),
  };
  obj.records = {
    label: patient.record.length,
    redirectPath: `/patient/${patient.id}/record`,
    data: patient.record.map((ele) => ({
      label: ele.name,
      id: ele.id,
    })),
  };

  obj.site = "Dr. John Samuel";
  return obj;
};

export const getMappedPatientForProvider = (patient) => {
  var obj = {};

  obj.patient = {
    label: patient.name,
    subLabel: patient.activity ? getActiveMessage(patient.activity) : "-",
    redirectPath: `/patient/${patient.id}`,
  };

  obj.nextEvent = {
    label: patient.next_schedule_event ? patient.next_schedule_event : "-",
    subLabel: patient.next_schedule
      ? DateTime.fromMillis(patient.next_schedule).toFormat("DD")
      : "-",
    redirectPath: `/patient/${patient.id}`,
  };

  obj.facesheet = {
    redirectPath: `/patient/${patient.id}/report`,
  }

  let completed = 0
  if (patient.questionnaire) {
    completed = patient.questionnaire.reduce((acc, val) => {
      if (val.completed) return acc + 1;
      return acc;
    }, 0);
  }

  obj.qnairs = {
    label: (patient.questionnaire)
      ? `${completed} of ${patient.questionnaire.length}`
      : "-",
    redirectPath: `/patient/${patient.id}/response`,
    data: [],
  };

  obj.surveys = {
    label: patient.survey.length,
    redirectPath: `/patient/${patient.id}/record`,
    flag: patient.survey.reduce((acc, val) => {
      if (val.modified_by) {
        if (acc.open) {
          acc.open = acc.open + 1;
        } else acc.open = 1;
        return acc;
      }
      if (acc.closed) acc.closed = acc.closed + 1;
      else acc.closed = 1;
      return acc;
    }, {}),
  };
  obj.files = {
    label: patient.file.length,
    redirectPath: `/patient/${patient.id}/record`,
    data: patient.file.map((ele) => ({
      label: ele.name,
      id: ele.id,
    })),
  };
  obj.records = {
    label: patient.record.length,
    redirectPath: `/patient/${patient.id}/record`,
    data: patient.record.map((ele) => ({
      label: ele.name,
      id: ele.id,
    })),
  };

  obj.site = "Dr. John Samuel";
  return obj;
};
